import { useState, useEffect } from "react";
import { Frame, Loading, Header, ValidaUid } from "../components";
import { db, storage } from "../config/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  setDoc,
  orderBy,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { Button, Col, Row, Modal } from "react-bootstrap";
import { MoedaBr } from "../components/Formatar";

const SISTEMA = "cangucu2026";

const Financeiro = () => {
  const [usuario, setUsuario] = useState(null);
  const [financeiro, setFinanceiro] = useState([]);
  const [valesExtra, setValesExtra] = useState({});
  const [arquivos, setArquivos] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const navigate = useNavigate();

  const opcoesCreditos = Array.from({ length: 20 }, (_, i) => i + 1);

  const getCampo = (campo, comp) => usuario?.[`${campo}${comp}`];

  const buscarUsuario = async (uid) => {
    const snap = await getDoc(doc(db, SISTEMA, uid));
    const data = snap.data();
    return data?.status === "a" ? data : null;
  };

  const buscarFinanceiro = async (modalidade) => {
    const snap = await getDocs(
      query(
        collection(db, "financeiro"),
        where("sistema", "==", SISTEMA),
        where("modalidade", "==", modalidade),
        where("ativo", "==", "1"),
        orderBy("competencia", "asc"),
      ),
    );

    console.log(snap.docs.map((doc) => doc.data()));

    return snap.docs.map((doc) => doc.data());
  };

  const uploadArquivo = async (file, campoStatus, campoUrl) => {
    const path = ref(storage, `${SISTEMA}/${usuario.uid}/${campoStatus}`);
    const upload = uploadBytesResumable(path, file);

    return new Promise((resolve) => {
      upload.on("state_changed", null, console.error, async () => {
        const url = await getDownloadURL(upload.snapshot.ref);
        resolve(url);
      });
    });
  };

  const enviarMensalidade = async (comp) => {
    const file = arquivos["pagto" + comp];
    if (!file) return;

    setLoading(true);

    const url = await uploadArquivo(file, "pagto" + comp);

    await setDoc(
      doc(db, SISTEMA, usuario.uid),
      {
        ["pagto" + comp]: "Enviado",
        ["urlPagto" + comp]: url,
      },
      { merge: true },
    );

    await carregarDados();
    setLoading(false);
    setModalShow(true);
  };

  const enviarExtra = async (comp) => {
    const file = arquivos["pagtoExtra" + comp];
    if (!file) return;

    setLoading(true);

    const url = await uploadArquivo(file, "pagtoExtra" + comp);

    await setDoc(
      doc(db, SISTEMA, usuario.uid),
      {
        ["pagtoExtra" + comp]: "Enviado",
        ["urlPagtoExtra" + comp]: url,
        ["creditosExtra" + comp]: valesExtra[comp] || 1,
      },
      { merge: true },
    );

    await carregarDados();
    setLoading(false);
    setModalShow(true);
  };

  const confirmarEnvio = () => {
    setModalShow(false);
  };

  const carregarDados = async () => {
    const uid = await ValidaUid();

    if (!uid) {
      navigate("../login");
      return;
    }

    const user = await buscarUsuario(uid);

    if (!user) {
      navigate("../home");
      return;
    }

    setUsuario(user);

    const dadosFinanceiro = await buscarFinanceiro(user.modalidade);

    setFinanceiro(dadosFinanceiro);
    setLoading(false);
  };

  useEffect(() => {
    carregarDados();
  }, []);

  return (
    <>
      {loading && <Loading />}

      <Header nome={usuario?.nome} foto={usuario?.urlFoto} />

      <Frame
        title="Financeiro"
        body={
          <>
            <div className="my-4">
              <div className="mb-4">
                <p>
                  <i>
                    Para pagar sua mensalidade faça um PIX e envie o comprovante
                    no mês correspondente.
                  </i>
                </p>
                <p>
                  <i>
                    Se precisar de saldo além do mensal contratado, faça a
                    solicitação de saldo extra.
                  </i>
                </p>
              </div>

              <div>
                <h5>Chave PIX CNPJ</h5>
                <h5>92.189.612/0001-92</h5>
              </div>
            </div>

            {financeiro.map((doc) => {
              const comp = doc.competencia;

              const pagto = getCampo("pagto", comp);
              const pagtoExtra = getCampo("pagtoExtra", comp);

              const urlPagto = getCampo("urlPagto", comp);
              const urlPagtoExtra = getCampo("urlPagtoExtra", comp);

              const creditos = getCampo("creditosExtra", comp) || 0;

              const qtdExtra = valesExtra[comp] || 1;
              const valorExtra = qtdExtra * doc.valorCredito;

              return (
                <div className="border rounded p-3 mb-3" key={comp}>
                  <h5>{doc.descricao}</h5>

                  <hr />

                  {/* Mensalidade */}
                  <Row className="mb-3">
                    <Col>
                      <strong>Mensalidade</strong>
                    </Col>
                    <Col>{doc.quantidadeCredito} créditos</Col>
                    <Col> {MoedaBr(doc.valorMesNormal)}</Col>

                    <Col>
                      {pagto ? (
                        <Col>
                          <span className="badge bg-success">{pagto}</span>
                        </Col>
                      ) : (
                        <Col>
                          <span className="badge bg-danger">Não Pago</span>
                        </Col>
                      )}
                    </Col>

                    {!pagto && (
                      <Col sm={2}>
                        <input
                          id={"filePagto" + comp}
                          type="file"
                          hidden
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={(e) =>
                            setArquivos((prev) => ({
                              ...prev,
                              ["pagto" + comp]: e.target.files[0],
                            }))
                          }
                        />

                        <label
                          htmlFor={"filePagto" + comp}
                          className="btn btn-outline-primary btn-sm"
                        >
                          Anexar arquivo
                        </label>

                        {arquivos["pagto" + comp] && (
                          <small className="d-block text-truncate">
                            {arquivos["pagto" + comp].name}
                          </small>
                        )}
                      </Col>
                    )}

                    {!pagto && (
                      <Col>
                        <Button
                          size="sm"
                          disabled={!arquivos["pagto" + comp]}
                          onClick={() => enviarMensalidade(comp)}
                        >
                          Enviar
                        </Button>
                      </Col>
                    )}

                    {pagto && urlPagto && (
                      <Col>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          href={urlPagto}
                          target="_blank"
                        >
                          Comprovante
                        </Button>
                      </Col>
                    )}
                  </Row>

                  {/* Extra */}

                  {pagtoExtra && (
                    <>
                      <hr />
                      <Row className="mb-2">
                        <Col>
                          <strong>Extra</strong>{" "}
                        </Col>

                        <Col>{creditos} créditos</Col>
                        <Col> {MoedaBr(creditos * doc.valorCredito)}</Col>

                        <Col>
                          <span className="badge bg-success">{pagtoExtra}</span>
                        </Col>

                        {urlPagtoExtra && (
                          <Col>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              href={urlPagtoExtra}
                              target="_blank"
                            >
                              Comprovante
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </>
                  )}
                  {pagto && !pagtoExtra && (
                    <>
                      {" "}
                      <hr />
                      <Row>
                        <Col>
                          <strong>Extra</strong>
                        </Col>

                        <Col>
                          <span className="badge bg-secondary">Opcional</span>
                        </Col>

                        <Col>
                          <select
                            className="form-select form-select-sm"
                            value={qtdExtra}
                            onChange={(e) =>
                              setValesExtra((prev) => ({
                                ...prev,
                                [comp]: Number(e.target.value),
                              }))
                            }
                          >
                            {opcoesCreditos.map((qtd) => (
                              <option key={qtd} value={qtd}>
                                {qtd}
                              </option>
                            ))}
                          </select>
                        </Col>

                        <Col>
                          <div className="form-control form-control-sm">
                            {MoedaBr(valorExtra)}
                          </div>
                        </Col>

                        <Col className="text-truncate">
                          <input
                            id={"filePagtoExtra" + comp}
                            type="file"
                            hidden
                            accept=".jpg,.jpeg,.png,.pdf"
                            onChange={(e) =>
                              setArquivos((prev) => ({
                                ...prev,
                                ["pagtoExtra" + comp]: e.target.files[0],
                              }))
                            }
                          />

                          <label
                            htmlFor={"filePagtoExtra" + comp}
                            className="btn btn-outline-primary btn-sm"
                          >
                            Anexar arquivo
                          </label>

                          {arquivos["pagtoExtra" + comp] && (
                            <small className="d-block text-truncate">
                              {arquivos["pagtoExtra" + comp].name}
                            </small>
                          )}
                        </Col>

                        <Col>
                          <Button
                            size="sm"
                            disabled={!arquivos["pagtoExtra" + comp]}
                            onClick={() => enviarExtra(comp)}
                          >
                            Enviar
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              );
            })}
          </>
        }
      />

      <Modal show={modalShow} onHide={confirmarEnvio} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sucesso</Modal.Title>
        </Modal.Header>

        <Modal.Body>Comprovante enviado com sucesso!</Modal.Body>

        <Modal.Footer>
          <Button onClick={confirmarEnvio}>OK</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Financeiro;
